/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as RessourcesRouteImport } from './routes/ressources'
import { Route as MerciRouteImport } from './routes/merci'
import { Route as MentionsLegalesRouteImport } from './routes/mentions-legales'
import { Route as LinksRouteImport } from './routes/links'
import { Route as LexiqueRouteImport } from './routes/lexique'
import { Route as GuideRouteImport } from './routes/guide'
import { Route as ConfidentialiteRouteImport } from './routes/confidentialite'
import { Route as ColophonRouteImport } from './routes/colophon'
import { Route as CarnetRouteImport } from './routes/carnet'
import { Route as CalculatriceRouteImport } from './routes/calculatrice'
import { Route as IndexRouteImport } from './routes/index'

const RessourcesRoute = RessourcesRouteImport.update({
  id: '/ressources',
  path: '/ressources',
  getParentRoute: () => rootRouteImport,
} as any)
const MerciRoute = MerciRouteImport.update({
  id: '/merci',
  path: '/merci',
  getParentRoute: () => rootRouteImport,
} as any)
const MentionsLegalesRoute = MentionsLegalesRouteImport.update({
  id: '/mentions-legales',
  path: '/mentions-legales',
  getParentRoute: () => rootRouteImport,
} as any)
const LinksRoute = LinksRouteImport.update({
  id: '/links',
  path: '/links',
  getParentRoute: () => rootRouteImport,
} as any)
const LexiqueRoute = LexiqueRouteImport.update({
  id: '/lexique',
  path: '/lexique',
  getParentRoute: () => rootRouteImport,
} as any)
const GuideRoute = GuideRouteImport.update({
  id: '/guide',
  path: '/guide',
  getParentRoute: () => rootRouteImport,
} as any)
const ConfidentialiteRoute = ConfidentialiteRouteImport.update({
  id: '/confidentialite',
  path: '/confidentialite',
  getParentRoute: () => rootRouteImport,
} as any)
const ColophonRoute = ColophonRouteImport.update({
  id: '/colophon',
  path: '/colophon',
  getParentRoute: () => rootRouteImport,
} as any)
const CarnetRoute = CarnetRouteImport.update({
  id: '/carnet',
  path: '/carnet',
  getParentRoute: () => rootRouteImport,
} as any)
const CalculatriceRoute = CalculatriceRouteImport.update({
  id: '/calculatrice',
  path: '/calculatrice',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/calculatrice': typeof CalculatriceRoute
  '/carnet': typeof CarnetRoute
  '/colophon': typeof ColophonRoute
  '/confidentialite': typeof ConfidentialiteRoute
  '/guide': typeof GuideRoute
  '/lexique': typeof LexiqueRoute
  '/links': typeof LinksRoute
  '/mentions-legales': typeof MentionsLegalesRoute
  '/merci': typeof MerciRoute
  '/ressources': typeof RessourcesRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/calculatrice': typeof CalculatriceRoute
  '/carnet': typeof CarnetRoute
  '/colophon': typeof ColophonRoute
  '/confidentialite': typeof ConfidentialiteRoute
  '/guide': typeof GuideRoute
  '/lexique': typeof LexiqueRoute
  '/links': typeof LinksRoute
  '/mentions-legales': typeof MentionsLegalesRoute
  '/merci': typeof MerciRoute
  '/ressources': typeof RessourcesRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/calculatrice': typeof CalculatriceRoute
  '/carnet': typeof CarnetRoute
  '/colophon': typeof ColophonRoute
  '/confidentialite': typeof ConfidentialiteRoute
  '/guide': typeof GuideRoute
  '/lexique': typeof LexiqueRoute
  '/links': typeof LinksRoute
  '/mentions-legales': typeof MentionsLegalesRoute
  '/merci': typeof MerciRoute
  '/ressources': typeof RessourcesRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/calculatrice'
    | '/carnet'
    | '/colophon'
    | '/confidentialite'
    | '/guide'
    | '/lexique'
    | '/links'
    | '/mentions-legales'
    | '/merci'
    | '/ressources'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/calculatrice'
    | '/carnet'
    | '/colophon'
    | '/confidentialite'
    | '/guide'
    | '/lexique'
    | '/links'
    | '/mentions-legales'
    | '/merci'
    | '/ressources'
  id:
    | '__root__'
    | '/'
    | '/calculatrice'
    | '/carnet'
    | '/colophon'
    | '/confidentialite'
    | '/guide'
    | '/lexique'
    | '/links'
    | '/mentions-legales'
    | '/merci'
    | '/ressources'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CalculatriceRoute: typeof CalculatriceRoute
  CarnetRoute: typeof CarnetRoute
  ColophonRoute: typeof ColophonRoute
  ConfidentialiteRoute: typeof ConfidentialiteRoute
  GuideRoute: typeof GuideRoute
  LexiqueRoute: typeof LexiqueRoute
  LinksRoute: typeof LinksRoute
  MentionsLegalesRoute: typeof MentionsLegalesRoute
  MerciRoute: typeof MerciRoute
  RessourcesRoute: typeof RessourcesRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/ressources': {
      id: '/ressources'
      path: '/ressources'
      fullPath: '/ressources'
      preLoaderRoute: typeof RessourcesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/merci': {
      id: '/merci'
      path: '/merci'
      fullPath: '/merci'
      preLoaderRoute: typeof MerciRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mentions-legales': {
      id: '/mentions-legales'
      path: '/mentions-legales'
      fullPath: '/mentions-legales'
      preLoaderRoute: typeof MentionsLegalesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/links': {
      id: '/links'
      path: '/links'
      fullPath: '/links'
      preLoaderRoute: typeof LinksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lexique': {
      id: '/lexique'
      path: '/lexique'
      fullPath: '/lexique'
      preLoaderRoute: typeof LexiqueRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/guide': {
      id: '/guide'
      path: '/guide'
      fullPath: '/guide'
      preLoaderRoute: typeof GuideRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/confidentialite': {
      id: '/confidentialite'
      path: '/confidentialite'
      fullPath: '/confidentialite'
      preLoaderRoute: typeof ConfidentialiteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/colophon': {
      id: '/colophon'
      path: '/colophon'
      fullPath: '/colophon'
      preLoaderRoute: typeof ColophonRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/carnet': {
      id: '/carnet'
      path: '/carnet'
      fullPath: '/carnet'
      preLoaderRoute: typeof CarnetRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/calculatrice': {
      id: '/calculatrice'
      path: '/calculatrice'
      fullPath: '/calculatrice'
      preLoaderRoute: typeof CalculatriceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CalculatriceRoute: CalculatriceRoute,
  CarnetRoute: CarnetRoute,
  ColophonRoute: ColophonRoute,
  ConfidentialiteRoute: ConfidentialiteRoute,
  GuideRoute: GuideRoute,
  LexiqueRoute: LexiqueRoute,
  LinksRoute: LinksRoute,
  MentionsLegalesRoute: MentionsLegalesRoute,
  MerciRoute: MerciRoute,
  RessourcesRoute: RessourcesRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
